import { useQuery } from "@tanstack/react-query";
import { getDriverProfile, getDrivers, getDriversWithProfiles } from "@/lib/drivers";

export function useDrivers() {
  return useQuery({
    queryKey: ["drivers", "list"],
    queryFn: () => getDrivers(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useDriversDetailed() {
  return useQuery({
    queryKey: ["drivers", "detailed"],
    queryFn: () => getDriversWithProfiles(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useDriverProfile(driverId: string | undefined) {
  return useQuery({
    queryKey: ["drivers", "profile", driverId],
    queryFn: () => getDriverProfile({ data: { driverId: driverId! } }),
    enabled: !!driverId,
    staleTime: 5 * 60 * 1000,
  });
}
